<template>
  <div class="cp-alt-text-image">
    <div class="teq-container">
      <div class="item">
        <h2 class="-mobile">
          louez un véhicule Renault électrique
        </h2>
        <div
          class="illust-container"
        >
          <img
            class="illust"
            src="../../../images/vehicule_electrique.webp"
            alt=""
          >
        </div>
        <div
          class="content"
        >
          <h2 class="-desktop">
            louez un véhicule Renault électrique
          </h2>
          <div
            class="text"
          >
            <p>Conduire un véhicule électrique n’a jamais été aussi simple qu’avec Mobilize Share. Grâce à la location courte durée, découvrez les nombreux avantages qu'offrent la conduite électrique avec notre gamme de véhicules Zéro Emission (Z.E). </p>
            <p>Mobilize Share dispose du plus grand parc de véhicules électriques disponibles à la location en France, afin de répondre à tous les besoins de déplacement.</p>
          </div>
          <arrow-link :href="'/vehicules?ev=1'" />
        </div>
      </div>
      <!-- FRONT to BACK : Il faut ajouter la possibilité dans le bo de mettre le classe '-flex-order' sur le bloc 'item' pour changer l'ordred'affichage -->
      <div class="item -flex-order">
        <h2 class="-mobile">
          besoin d’un véhicule de remplacement ?
        </h2>
        <div
          class="illust-container"
        >
          <img
            class="illust"
            src="../../../images/vehicule_remplacement.webp"
            alt=""
          >
        </div>
        <div
          class="content"
        >
          <h2 class="-desktop">
            besoin d’un véhicule de remplacement ?
          </h2>
          <div
            class="text"
          >
            <p>Votre véhicule est immobilisé alors que vous devez voyager ? Mobilize Share vous met à disposition un véhicule de remplacement récent de la gamme Renault, pour assurer vos déplacements au quotidien.</p>
          </div>
          <arrow-link :href="'/vehicule-de-remplacement'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArrowLink from '../shared/ArrowLink'

export default {
  name: 'MobilityAltImageText',

  components: {
    ArrowLink,
  },
}
</script>

<style lang="scss" scoped>
@import "../../../../_src/sass/config/vars";
@import "../../../../_src/sass/config/mixins";
@import "../../../../_src/sass/config/responsive";

.cp-alt-text-image {
  margin-bottom: 4rem;
}

.teq-container {
  box-sizing: border-box;
  flex-wrap: wrap;
  margin: 0 auto;
  max-width: 100%;
  padding-top: 8rem;
  width: 100% !important;

  @include teq-breakpoint($medium-large) {
    margin: 0 auto;
    max-width: 77rem;
  }

  @include teq-breakpoint($large) {
    max-width: 100%;
    max-width: 96rem;
  }

  @include teq-breakpoint($wide) {
    max-width: 118rem;
  }
}

.item {
  margin-bottom: 2rem;
  width: 100%;

  @include teq-breakpoint($large) {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 0;
  }

  &.-flex-order {
    .illust-container {
      order: 1;
    }

    .content {
      order: 2;
    }
  }

  &:nth-child(2) {
    margin-top: 6rem;
  }
}

.illust-container {
  order: 2;
  overflow: hidden;
  position: relative;
  width: 100%;

  @include teq-breakpoint($large) {
    margin-bottom: 0;
    width: calc(50% - 1rem);
  }

  &::before {
    content: "";
    display: block;
    padding-top: (111 / 116) * 100%;
    width: 100%;
  }
}

.illust {
  height: 100%;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 100%;
}

.content {
  box-sizing: border-box;
  order: 1;
  padding: 3.5rem 2.8rem 0;
  width: 100%;

  @include teq-breakpoint($large) {
    padding: 7.5rem 7rem 0;
    width: calc(50% - 1rem);
  }
}

h2 {
  @include teq-breakpoint($large) {
    margin: 2rem 0 6.5rem;
    text-align: left;

    &::before {
      background: #000;
      bottom: -2.8rem;
      content: '';
      height: 2px;
      left: 0;
      position: absolute;
      transform: none;
      width: 6.4rem;
    }
  }

  &.-mobile {
    @include teq-breakpoint($large) {
      display: none;
    }
  }

  &.-desktop {
    display: none;

    @include teq-breakpoint($large) {
      display: block;
      line-height: 4.2rem;
    }
  }
}

.text {
  margin-bottom: 3rem;

  p {
    color: #222;
    font-family: $f-graphie-book;
    font-size: 1.6rem;
    line-height: 2.6rem;
    margin-bottom: 1rem;
  }
}

</style>
